import { useTenantProfile } from 'hooks/api/tenant/useTenantProfile'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

export const StripeWrapper = ({ children }) => {
	const { data: tenantProfile } = useTenantProfile()
	const tenantStripeToken = tenantProfile?.config?.stripePublicKey
	const stripePromise = loadStripe(tenantStripeToken)

	return (
		<Elements
			stripe={stripePromise}
			options={{
				mode: 'setup',
				currency: 'usd',
				paymentMethodOptions: { us_bank_account: { verification_method: 'instant' } },
				setupFutureUsage: 'off_session',
				paymentMethodTypes: ['card', 'us_bank_account'],
			}}
		>
			{children}
		</Elements>
	)
}
